module.exports = {"451081100":"新靖镇","451081101":"化峒镇","451081102":"湖润镇","451081103":"安德镇","451081104":"龙临镇","451081105":"渠洋镇","451081106":"岳圩镇","451081107":"龙邦镇","451081108":"禄峒镇","451081109":"武平镇","451081110":"地州镇","451081200":"同德乡","451081201":"壬庄乡","451081202":"安宁乡","451081206":"南坡乡","451081207":"吞盘乡","451081209":"果乐乡","451081211":"新甲乡","451081215":"魁圩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451081.json
// module id = 2280
// module chunks = 0